// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { TicketType, TicketTypeData } from '../../common/types.tsx';
import { updateTicketTypeService } from '../../services/update-ticket-type/index.tsx';

export const updateTicketType =
	(ticketTypeId: string, ticketType: TicketType): Action<TicketTypeData> =>
	async ({ getState, setState }) => {
		const {
			appProps: { projectId },
		} = getState();

		await updateTicketTypeService(ticketType, projectId);
		const { ticketTypes: currentTicketTypes } = getState();

		const updatedTicketTypes = {
			...currentTicketTypes,
			[ticketTypeId]: { currentState: ticketType, updateState: {} },
		};
		setState({ ticketTypes: updatedTicketTypes });
	};
